/* eslint-disable max-lines */
export const COMMON = [
  {
    name: 'color',
    description: 'color',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'bg',
    description: 'background-color',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'background',
    description: 'background',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'm',
    description: 'margin',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'mt',
    description: 'margin-top',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'mr',
    description: 'margin-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'mb',
    description: 'margin-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'ml',
    description: 'margin-left',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'mx',
    description: 'margin-left and margin-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'my',
    description: 'margin-top and margin-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'p',
    description: 'padding',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'pt',
    description: 'padding-top',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'pr',
    description: 'padding-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'pb',
    description: 'padding-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'pl',
    description: 'padding-left',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'px',
    description: 'padding-left and padding-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'py',
    description: 'padding-top and padding-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
export const BORDER = [
  {
    name: 'border',
    description: 'border',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderWidth',
    description: 'border-width',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderStyle',
    description: 'border-style',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderColor',
    description: 'border-color',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderRadius',
    description: 'border-radius',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderTop',
    description: 'border-top',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderRight',
    description: 'border-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderBottom',
    description: 'border-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderLeft',
    description: 'border-left',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderX',
    description: 'border-left and border-right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'borderY',
    description: 'border-top and border-bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
export const TYPOGRAPHY = [
  {
    name: 'fontFamily',
    description: 'font-family',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'fontSize',
    description: 'font-size',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'fontWeight',
    description: 'font-weight',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'lineHeight',
    description: 'line-height',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'letterSpacing',
    description: 'letter-spacing',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'textAlign',
    description: 'text-align',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'fontStyle',
    description: 'font-style',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
export const LAYOUT = [
  {
    name: 'display',
    description: 'display',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'size',
    description: 'height and width',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'width',
    description: 'width',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'height',
    description: 'height',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'minWidth',
    description: 'min-width',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'minHeight',
    description: 'min-height',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'maxWidth',
    description: 'max-width',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'maxHeight',
    description: 'max-height',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'overflow',
    description: 'overflow',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'verticalAlign',
    description: 'vertical-align',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
export const POSITION = [
  {
    name: 'position',
    description: 'position',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'zIndex',
    description: 'z-ndex',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'top',
    description: 'top',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'right',
    description: 'right',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'bottom',
    description: 'bottom',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'left',
    description: 'left',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
export const FLEXBOX = [
  {
    name: 'flexDirection',
    description: 'flex-direction',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'flexWrap',
    description: 'flex-wrap',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'alignContent',
    description: 'align-content',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'alignItems',
    description: 'align-items',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'justifyContent',
    description: 'justify-content',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'justifyItems',
    description: 'justify-items',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'order',
    description: 'order',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'flex',
    description: 'flex',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'flexBasis',
    description: 'flex-basis',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'justifySelf',
    description: 'justify-self',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'alignSelf',
    description: 'align-self',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
  {
    name: 'height',
    description: 'height',
    type: 'System',
    defaultValue: 'undefined',
    responsive: 'true',
  },
];
